import { useEffect } from 'react';
import { RequiredChecklistGenericConfetti } from 'components/required-checklist/RequiredChecklistGenericConfetti';
import { useAccountLocalStorage } from 'contexts/useAccountLocalStorage';

const ChecklistHomepageConfetti = () => {
    const { setHasSeenCompletedConfetti } = useAccountLocalStorage(
        ({ setHasSeenCompletedConfetti }) => ({ setHasSeenCompletedConfetti }),
    );

    useEffect(() => {
        const confettiViewed = setTimeout(() => {
            setHasSeenCompletedConfetti(true);
        }, 3000);
        return () => {
            clearTimeout(confettiViewed);
        };
    }, [setHasSeenCompletedConfetti]);
    return <RequiredChecklistGenericConfetti className="fixed max-h-screen" />;
};

export { ChecklistHomepageConfetti };
